(() => {
  'use strict';

  const ROOT = 'product-info[id^="MainProduct-"]';
  const FORM = '#tee-artwork-form, .tee-artwork-form, [id*="tee-artwork-form"]';
  const NATIVE_HIDDEN = 'mg-v5-native-hidden';
  const LAYOUT_HIDDEN = 'mg-v5-layout-hidden';
  const bootedRoots = new WeakSet();
  const movedOrigins = new WeakMap();
  const variantState = {
    size: '',
    finish: '',
    transition: false,
    transitionToken: 0
  };

  let imageOptimizationState = '';

  function customizerEnabled(root) {
    return root?.dataset?.mgCustomizerEnabled !== 'false';
  }

  function restoreNativeFields() {
    document.querySelectorAll('.mg-v6-native-field').forEach((field) => {
      const marker = movedOrigins.get(field);
      if (marker?.isConnected) marker.replaceWith(field);
      field.classList.remove('mg-v6-native-field','mg-v6-design-field','mg-v6-media-field','mg-v6-personal-field','mg-v6-option-field','mg-v6-image-choice','mg-v6-upload-field','mg-v6-hide-native-title');
      field.style.removeProperty('--mg-v6-order');
    });
    document.querySelectorAll('.mg-v6-origin').forEach((marker) => marker.remove());
  }

  function disableCustomizer(root) {
    restoreNativeFields();
    root?.classList.remove('mg-v5-active', 'mg-v6-active', 'mg-v5-lite-active');
    document.body?.classList.remove('mg-v5-active', 'mg-v6-active', 'mg-v5-lite-active');
    document.querySelectorAll('.mg-v5-panel, .mg-v5-lite-panel, .mg-v5-lite-hero').forEach((node) => node.remove());
    document.querySelectorAll('.mg-v5-native-shell-hidden').forEach((node) => node.classList.remove('mg-v5-native-shell-hidden'));
    document.querySelectorAll('.' + NATIVE_HIDDEN).forEach((node) => node.classList.remove(NATIVE_HIDDEN, 'mg-v5-proxied'));
    document.querySelectorAll('.' + LAYOUT_HIDDEN).forEach((node) => node.classList.remove(LAYOUT_HIDDEN));
    document.querySelectorAll('[data-mg-lite-hidden="1"]').forEach((node) => {
      node.classList.remove(NATIVE_HIDDEN);
      node.removeAttribute('data-mg-lite-hidden');
    });
  }

  const DESIGN_PREVIEWS = [
    { name: 'Klassisches Design', image: 'https://cdn.teeinblue.com/users/26754/images/6a38d34cdeb28_large.webp' },
    { name: 'Elegantes Design', image: 'https://cdn.teeinblue.com/users/26754/images/6a38d33b95005_large.webp' },
    { name: 'Elegantes Design hell', image: 'https://cdn.teeinblue.com/users/26754/images/6a3cfa1b383cd_large.webp' }
  ];

  const BACKGROUND_PREVIEWS = {
    0: [
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/6981e7ba8c84d_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/698d874f05f6d_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/6981e7bcda2e8_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/69af2fac018cf_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/6a37fbd74c2dc_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2291115/69af55f20ce38_large.webp'
    ],
    1: [
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d4499e785_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d451572e2_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d45f73954_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d46130c9c_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d466550df_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d466c7778_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d46700a97_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2454604/6a16d469a92a0_large.webp'
    ],
    2: [
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3c94f449_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3cf61b7d_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d152700_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d1d48bc_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d23a91f_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d3e7918_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d47d8ce_large.webp',
      'https://cdn.teeinblue.com/users/26754/cliparts/2493634/6a3cf3d5e8eca_large.webp'
    ]
  };

  const FONT_CHOICES = [
    { id: '16528627', raw: 'Blacksword', thumb: 'https://cdn.teeinblue.com/users/26754/cliparts/1612653/685c17b57cf85_thumbnail.webp' },
    { id: '16528631', raw: 'GreatVibes-Regular', thumb: 'https://cdn.teeinblue.com/users/26754/cliparts/1612653/685c17b5e2472_thumbnail.webp' },
    { id: '16528629', raw: 'MarckScript-Regular', thumb: 'https://cdn.teeinblue.com/users/26754/cliparts/1612653/685c17b5ca846_thumbnail.webp' },
    { id: '29069713', raw: 'EBGaramond-VariableFont_wght', thumb: 'https://cdn.teeinblue.com/users/26754/cliparts/1612653/6a4a1ead1fa56_thumbnail.webp' },
    { id: '16528626', raw: 'playballregular', thumb: 'https://cdn.teeinblue.com/users/26754/cliparts/1612653/685c17b56f69e_thumbnail.webp' }
  ];

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const norm = (value) => clean(value).toLocaleLowerCase('de-DE')
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');

  const escapeHtml = (value) => String(value || '').replace(/[&<>\"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'
  }[char]));

  function cssEscape(value) {
    if (window.CSS?.escape) return CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~\\':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function labelFor(input) {
    if (!input) return null;
    if (input.id) {
      const label = document.querySelector(`label[for="${cssEscape(input.id)}"]`);
      if (label) return label;
    }
    return input.closest('label') || input.parentElement?.querySelector('label') || null;
  }

  function parseSrcset(value) {
    if (!value) return '';
    const items = value.split(',').map((item) => item.trim().split(/\s+/)[0]).filter(Boolean);
    return items.at(-1) || '';
  }

  function normalizeImageUrl(src) {
    return String(src || '')
      .replace(/^\/\//, 'https://')
      .replace(/_(?:small|medium|thumb|thumbnail)(\.[a-z0-9]+)(\?.*)?$/i, '_large$1$2')
      .replace(/\/small\//i, '/large/')
      .replace(/\/medium\//i, '/large/');
  }

  function bestImage(node, maxAncestors = 3) {
    if (!node) return '';
    const roots = [];
    let current = node;
    for (let i = 0; current && i <= maxAncestors; i++, current = current.parentElement) {
      roots.push(current);
      if (current.matches?.(FORM)) break;
    }

    for (const root of roots) {
      const image = root.matches?.('img') ? root : root.querySelector?.('img');
      const src = image?.currentSrc || image?.src || image?.dataset?.src || image?.dataset?.lazySrc;
      if (src) return normalizeImageUrl(src);

      const source = root.matches?.('source') ? root : root.querySelector?.('source[srcset]');
      const srcset = parseSrcset(source?.srcset || image?.srcset || image?.dataset?.srcset);
      if (srcset) return normalizeImageUrl(srcset);

      const dataImage = root.querySelector?.('[data-src], [data-image], [data-url], [data-thumbnail]');
      const dataSrc = dataImage?.dataset?.src || dataImage?.dataset?.image || dataImage?.dataset?.url || dataImage?.dataset?.thumbnail;
      if (dataSrc && /\.(?:png|jpe?g|webp|avif)(?:\?|$)/i.test(dataSrc)) return normalizeImageUrl(dataSrc);

      const backgroundNodes = [root, ...(root.querySelectorAll?.('[style*="background"], [class*="image"], [class*="thumb"]') || [])];
      for (const bgNode of backgroundNodes) {
        const inline = bgNode?.style?.backgroundImage;
        const computed = bgNode instanceof Element ? getComputedStyle(bgNode).backgroundImage : '';
        const match = (inline || computed || '').match(/url\(["']?(.*?)["']?\)/);
        if (match?.[1]) return normalizeImageUrl(match[1]);
      }
    }
    return '';
  }

  function clickNative(target) {
    if (!target) return;
    if (target instanceof HTMLInputElement && target.disabled) return;

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const active = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const restoreScroll = () => {
      window.scrollTo(scrollX, scrollY);
      if (active && active.isConnected && active !== document.body) {
        try { active.focus({ preventScroll: true }); } catch (_) {}
      }
    };

    if (target instanceof HTMLInputElement) {
      const isChoice = target.type === 'radio' || target.type === 'checkbox';
      const label = isChoice ? labelFor(target) : null;
      const clickTarget = label && !label.closest('.mg-v5-lite-panel, .mg-v5-panel') ? label : target;

      clickTarget.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
      clickTarget.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
      clickTarget.click();

      if (isChoice && !target.checked) {
        const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
        if (descriptor?.set) descriptor.set.call(target, true);
        else target.checked = true;
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      restoreScroll();
      requestAnimationFrame(restoreScroll);
      window.setTimeout(restoreScroll, 80);
      return;
    }

    target.dispatchEvent?.(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
    target.dispatchEvent?.(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
    target.click?.();
    restoreScroll();
    requestAnimationFrame(restoreScroll);
    window.setTimeout(restoreScroll, 80);
  }

  function setNativeValue(input, value) {
    if (!input) return;
    const prototype = input instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor?.set) descriptor.set.call(input, value);
    else input.value = value;
    try {
      input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: null }));
    } catch (_) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scheduleSync() {
    [0, 80, 180, 350, 700, 1200].forEach((delay) => {
      window.setTimeout(() => {
        const root = document.querySelector(ROOT);
        const form = document.querySelector(FORM);
        if (root && form) sync(root, form);
      }, delay);
    });
  }

  function findEditableText(field, anchor) {
    if (anchor instanceof HTMLInputElement || anchor instanceof HTMLTextAreaElement) return anchor;
    const candidates = Array.from(field?.querySelectorAll('textarea, input[type="text"]') || []).filter((input) => {
      if (input.disabled || input.readOnly) return false;
      const meta = norm([input.className, input.name, input.id, input.placeholder, input.getAttribute('aria-label')].filter(Boolean).join(' '));
      return !/(font|schrift|search|suche|color|farbe)/.test(meta);
    });
    return candidates[0] || null;
  }

  function findRadioGroup(words, minimum = 2, exclude = []) {
    const scope = document.querySelector(FORM) || document;
    const candidates = Array.from(scope.querySelectorAll('fieldset, .tee-field, .tee-form-group, .tee-form-input, .tee-option, [class*="field"], [class*="option"]'));
    const matches = candidates.filter((group) => {
      const radios = group.querySelectorAll('input[type="radio"]');
      if (radios.length < minimum) return false;
      const heading = group.querySelector('legend, :scope > label, :scope > h2, :scope > h3, :scope > h4, [class*="title"], [class*="label"]');
      const text = norm(heading?.textContent || group.getAttribute('data-label') || '');
      if (!words.some((word) => text.includes(norm(word)))) return false;
      if (exclude.some((word) => text.includes(norm(word)))) return false;
      return true;
    });
    matches.sort((a, b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length);
    return matches[0] || null;
  }

  function nativeField(anchor) {
    if (!anchor) return null;
    return anchor.closest('.tee-form-input, .tee-field, .tee-form-group, .tee-input-group, .tee-input-container, [class*="tee-field"], [class*="form-group"], .tee-block') || anchor.parentElement;
  }

  function scopedQuery(form, selector) {
    return form ? form.querySelector(selector) : null;
  }

  function currentForm() {
    return document.querySelector(FORM);
  }

  function currentField(selector) {
    const form = currentForm();
    const anchor = scopedQuery(form, selector);
    return { form, anchor, field: nativeField(anchor) };
  }

  function currentEditable(selector) {
    const { anchor, field } = currentField(selector);
    return findEditableText(field, anchor);
  }

  function currentRadioByLabel(words, exclude, rawLabel, nativeId) {
    const wanted = norm(rawLabel);
    if (nativeId) {
      const byId = document.getElementById(nativeId);
      if (byId instanceof HTMLInputElement && byId.type === 'radio' && byId.isConnected) {
        const text = norm(labelFor(byId)?.textContent || byId.value || '');
        if (text === wanted || text.includes(wanted) || wanted.includes(text)) return byId;
      }
    }
    const group = findRadioGroup(words, 2, exclude || []);
    if (!group) return null;
    return Array.from(group.querySelectorAll('input[type="radio"]')).find((radio) => {
      const text = norm(labelFor(radio)?.textContent || radio.value || '');
      return text === wanted || text.includes(wanted) || wanted.includes(text);
    }) || null;
  }

  function currentFinishRadio(rawLabel, nativeId) {
    const wantedName = finishName(rawLabel);
    if (nativeId) {
      const byId = document.getElementById(nativeId);
      if (byId instanceof HTMLInputElement && byId.type === 'radio' && byId.isConnected) {
        const raw = clean(labelFor(byId)?.textContent || byId.value || '');
        if (finishName(raw) === wantedName) return byId;
      }
    }
    const group = document.querySelector('#tee-field--teeinblue-available-prod') || findRadioGroup(['available product', 'ausführung', 'ausfuehrung', 'qualität', 'qualitaet'], 2);
    if (!group) return null;
    return Array.from(group.querySelectorAll('input[type="radio"]')).find((radio) => {
      const raw = clean(labelFor(radio)?.textContent || radio.value || '');
      return finishName(raw) === wantedName;
    }) || null;
  }

  function safeHideNative(element, form) {
    if (!element || !form) return;
    if (element === form || element.contains(form)) return;
    element.classList.add(NATIVE_HIDDEN, 'mg-v5-proxied');
  }

  function createSection(title, subtitle, className) {
    const section = document.createElement('section');
    section.className = `mg-v5-section ${className || ''}`.trim();
    section.innerHTML = `<div class="mg-v5-section-head"><div><h3>${escapeHtml(title)}</h3>${subtitle ? `<p>${escapeHtml(subtitle)}</p>` : ''}</div></div>`;
    return section;
  }

  function extractPrice(text) {
    const value = clean(text);
    const match = value.match(/(?:\+\s*)?\d{1,4}(?:[.,]\d{2})?\s*€/);
    return match?.[0] || '';
  }

  function selectedDesignIndex(form) {
    const group = findRadioGroup(['design wählen', 'design waehlen', 'design'], 2, ['größe', 'groesse', 'size', 'available product']);
    if (!group) return 0;
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    const index = radios.findIndex((input) => input.checked);
    return index >= 0 ? Math.min(index, DESIGN_PREVIEWS.length - 1) : 0;
  }

  function buildDesigns(panel, form) {
    const group = findRadioGroup(['design wählen', 'design waehlen', 'design'], 2, ['größe', 'groesse', 'size', 'available product']);
    if (!group) return;
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (radios.length < 2) return;

    const section = createSection('Design auswählen', 'Wähle dein Lieblingsdesign.', 'mg-v5-designs');
    const grid = document.createElement('div');
    grid.className = 'mg-v5-design-grid';

    radios.forEach((input, index) => {
      const preview = DESIGN_PREVIEWS[index] || DESIGN_PREVIEWS.at(-1);
      const title = preview?.name || `Design ${index + 1}`;
      const src = preview?.image || '';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mg-v5-design-card';
      button.dataset.nativeId = input.id || '';
      button.dataset.designIndex = String(index);
      button.innerHTML = `<span class="mg-v5-design-image"><img src="${escapeHtml(src)}" alt="${escapeHtml(title)}" loading="eager"><span class="mg-v5-check">✓</span></span><span class="mg-v5-design-name">${escapeHtml(title)}</span>`;
      button.addEventListener('click', () => {
        const liveForm = currentForm() || form;
        const liveGroup = findRadioGroup(['design wählen', 'design waehlen', 'design'], 2, ['größe', 'groesse', 'size', 'available product']);
        const liveRadios = Array.from(liveGroup?.querySelectorAll('input[type="radio"]') || []);
        const freshInput = liveRadios[index] || (input.isConnected ? input : null);
        forceChoiceEvent(freshInput);
        button.dataset.mgLastSelected = '1';
        grid.querySelectorAll('.mg-v5-design-card').forEach((entry) => {
          if (entry !== button) entry.dataset.mgLastSelected = '0';
        });
        window.setTimeout(() => refreshBackgroundGrid(liveForm, index), 160);
        scheduleSync();
      });
      grid.append(button);
    });

    section.append(grid);
    panel.append(section);
    safeHideNative(group, form);
  }

  function choiceTargets(field) {
    const radios = Array.from(field?.querySelectorAll('input[type="radio"]') || []);
    if (radios.length) {
      return radios.map((input, index) => {
        const label = labelFor(input);
        return {
          target: input,
          nativeId: input.id || '',
          title: clean(label?.getAttribute('title') || label?.textContent || input.value) || `Option ${index + 1}`,
          image: bestImage(label || input.parentElement, 5)
        };
      });
    }

    const candidates = Array.from(field?.querySelectorAll('button, [role="radio"], [role="option"], .tee-clipart-item, [class*="clipart"]') || [])
      .filter((el) => el instanceof HTMLElement && !el.closest('.mg-v5-panel'));
    const unique = [];
    for (const target of candidates) {
      const image = bestImage(target, 2);
      if (!image) continue;
      if (unique.some((item) => item.image === image)) continue;
      unique.push({
        target,
        nativeId: '',
        title: clean(target.getAttribute('title') || target.getAttribute('aria-label') || target.textContent) || `Option ${unique.length + 1}`,
        image
      });
    }
    return unique.slice(0, 20);
  }

  function setBinaryChoice(field, wanted) {
    if (!field) return false;
    const wantedNorm = norm(wanted);
    const radios = Array.from(field.querySelectorAll('input[type="radio"]'));
    for (const input of radios) {
      const label = labelFor(input);
      const text = norm(label?.textContent || input.value || '');
      if (text === wantedNorm || text.includes(wantedNorm)) {
        clickNative(input);
        return true;
      }
    }
    const select = field.querySelector('select');
    if (select) {
      const option = Array.from(select.options).find((item) => {
        const text = norm(item.textContent || item.value || '');
        return text === wantedNorm || text.includes(wantedNorm);
      });
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    const clickable = textClickable(field, wanted);
    if (clickable) {
      clickNative(clickable);
      return true;
    }
    return false;
  }

  function currentImageOptimizationField(form) {
    const liveForm = currentForm() || form;
    const anchor = scopedQuery(liveForm, '.mg-bildoptimerung, [class*="mg-bildoptim"]') || Array.from(liveForm?.querySelectorAll('.tee-form-input, .tee-field, .tee-form-group, .tee-input-group, .tee-input-container, [class*="form-group"]') || []).find((node) => /bildoptimierung/i.test(clean(node.textContent || '')));
    return nativeField(anchor);
  }

  function selectedBinaryValue(field) {
    if (!field) return '';
    const radio = Array.from(field.querySelectorAll('input[type="radio"]')).find((input) => input.checked);
    if (radio) return /nein/i.test(clean(labelFor(radio)?.textContent || radio.value || '')) ? 'Nein' : 'Ja';
    const select = field.querySelector('select');
    if (select?.value) return /nein/i.test(clean(select.selectedOptions?.[0]?.textContent || select.value)) ? 'Nein' : 'Ja';
    return '';
  }

  function applyImageOptimizationState(form) {
    if (!imageOptimizationState) return false;
    const field = currentImageOptimizationField(form);
    if (!field) return false;
    const current = selectedBinaryValue(field);
    if (current !== imageOptimizationState) setBinaryChoice(field, imageOptimizationState);
    document.querySelectorAll('.mg-v5-image-optimization .mg-v5-segment').forEach((button) => {
      const selected = button.dataset.value === imageOptimizationState;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    return true;
  }

  function forceChoiceEvent(target) {
    if (!target) return;
    const input = target instanceof HTMLInputElement ? target : target.querySelector?.('input[type="radio"], input[type="checkbox"]');
    if (input instanceof HTMLInputElement) {
      const wasChecked = input.checked;
      clickNative(input);
      if (wasChecked && input.checked) {
        input.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    clickNative(target);
  }

  function buildImageOptimization(body, form) {
    const field = currentImageOptimizationField(form);
    if (!field) return;
    if (!imageOptimizationState) imageOptimizationState = selectedBinaryValue(field) || 'Ja';

    const item = document.createElement('div');
    item.className = 'mg-v5-image-optimization';
    item.innerHTML = '<div><strong>Kostenlose Bildoptimierung</strong><span>Wir verbessern dein Foto bei Bedarf für ein möglichst gutes Druckergebnis.</span></div><div class="mg-v5-segmented"><button type="button" class="mg-v5-segment" data-value="Ja">Ja</button><button type="button" class="mg-v5-segment" data-value="Nein">Nein</button></div>';
    const buttons = Array.from(item.querySelectorAll('.mg-v5-segment'));
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        imageOptimizationState = button.dataset.value || '';
        applyImageOptimizationState(form);
        scheduleSync();
      });
    });
    body.append(item);
    safeHideNative(field, form);
    applyImageOptimizationState(form);
  }

  function popupChoiceByIndex(field, index) {
    const existing = choiceTargets(field);
    if (existing[index]?.target) {
      clickNative(existing[index].target);
      return;
    }
    const opener = field?.querySelector('button, [role="button"], .tee-clipart-current, [class*="select"]');
    if (!opener) return;
    clickNative(opener);
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      const roots = Array.from(document.querySelectorAll('.tee-dialog, [role="dialog"], [role="listbox"], .vm--container, [class*="popover"], [class*="dropdown"]'));
      const options = roots.flatMap((root) => Array.from(root.querySelectorAll('input[type="radio"], [role="radio"], [role="option"], .tee-clipart-item, button')))
        .filter((el) => !el.closest('.mg-v5-panel'));
      if (options[index]) {
        window.clearInterval(timer);
        clickNative(options[index]);
      } else if (tries >= 12) window.clearInterval(timer);
    }, 80);
  }

  function refreshBackgroundGrid(form, requestedDesignIndex) {
    const grid = document.querySelector('.mg-v5-background-grid');
    if (!grid) return;
    const designIndex = Number.isInteger(requestedDesignIndex) ? requestedDesignIndex : selectedDesignIndex(form);
    const images = BACKGROUND_PREVIEWS[designIndex] || BACKGROUND_PREVIEWS[0];
    const backgroundAnchor = scopedQuery(form, '.mg-hintergrund, .mg-hintergrund-anchor');
    const field = nativeField(backgroundAnchor);
    const targets = choiceTargets(field);
    grid.innerHTML = '';
    images.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mg-v5-background-card';
      if (targets[index]?.nativeId) button.dataset.nativeId = targets[index].nativeId;
      button.innerHTML = `<img src="${escapeHtml(src)}" alt="Hintergrund ${index + 1}" loading="lazy"><span class="mg-v5-check">✓</span>`;
      button.addEventListener('click', () => {
        const liveForm = currentForm() || form;
        const liveAnchor = scopedQuery(liveForm, '.mg-hintergrund, .mg-hintergrund-anchor');
        const liveField = nativeField(liveAnchor) || field;
        const liveTargets = choiceTargets(liveField);
        if (liveTargets[index]?.target) forceChoiceEvent(liveTargets[index].target);
        else popupChoiceByIndex(liveField, index);
        grid.querySelectorAll('.mg-v5-background-card').forEach((entry) => {
          entry.classList.remove('is-selected');
          entry.dataset.mgLastSelected = '0';
        });
        button.classList.add('is-selected');
        button.dataset.mgLastSelected = '1';
        scheduleSync();
      });
      grid.append(button);
    });
  }

  function buildUploadAndBackground(panel, form) {
    const photoAnchor = scopedQuery(form, '.mg-bild, .mg-bild-anchor');
    const backgroundAnchor = scopedQuery(form, '.mg-hintergrund, .mg-hintergrund-anchor');
    if (!photoAnchor && !backgroundAnchor) return;

    const section = createSection('Foto & Hintergrund', 'Lade dein Foto hoch und wähle die passende Bildstimmung.', 'mg-v5-photo-section');
    const body = document.createElement('div');
    body.className = 'mg-v5-photo-grid';

    if (photoAnchor) {
      const initialField = nativeField(photoAnchor);
      const getPhotoField = () => currentField('.mg-bild, .mg-bild-anchor').field || initialField;
      const findFileInput = () => getPhotoField()?.querySelector('input[type="file"]');
      const findUploadTrigger = () => {
        const field = getPhotoField();
        return Array.from(field?.querySelectorAll('button, label[for], [role="button"], a') || []).find((el) => {
          const meta = norm([el.textContent, el.getAttribute('aria-label'), el.getAttribute('title'), el.className].filter(Boolean).join(' '));
          return /(foto|bild|upload|hochladen|datei|waehlen|select)/.test(meta) && !/(ausricht|position|bearbeit|edit|crop)/.test(meta);
        }) || currentField('.mg-bild, .mg-bild-anchor').anchor;
      };
      const findRepositionTrigger = () => {
        const field = getPhotoField();
        return Array.from(field?.querySelectorAll('button, [role="button"], a, label') || []).find((el) => {
          const meta = norm([el.textContent, el.getAttribute('aria-label'), el.getAttribute('title'), el.className].filter(Boolean).join(' '));
          return /(ausricht|position|bearbeit|edit|crop|platzier|anpass)/.test(meta) && !el.closest('.mg-v5-panel');
        });
      };

      const upload = document.createElement('button');
      upload.type = 'button';
      upload.className = 'mg-v5-upload';
      upload.innerHTML = '<span class="mg-v5-upload-icon">＋</span><span><strong>Foto hochladen</strong><small>JPG, PNG oder HEIC · möglichst Originaldatei</small></span>';
      upload.addEventListener('click', () => {
        const fileInput = findFileInput();
        if (fileInput) fileInput.click();
        else findUploadTrigger()?.click?.();
      });
      body.append(upload);

      document.addEventListener('change', (event) => {
        const input = event.target instanceof HTMLInputElement && event.target.type === 'file' ? event.target : null;
        if (!input || !getPhotoField()?.contains(input)) return;
        const name = input.files?.[0]?.name;
        if (name) upload.querySelector('small').textContent = name;
      }, true);

      const reposition = document.createElement('button');
      reposition.type = 'button';
      reposition.className = 'mg-v5-secondary-action mg-v5-reposition';
      reposition.textContent = 'Bild ausrichten';
      reposition.addEventListener('click', () => {
        const trigger = findRepositionTrigger();
        if (trigger) trigger.click();
        else findUploadTrigger()?.click?.();
      });
      body.append(reposition);

      buildImageOptimization(body, form);
      safeHideNative(initialField, form);
    }

    if (backgroundAnchor) {
      const field = nativeField(backgroundAnchor);
      const wrap = document.createElement('div');
      wrap.className = 'mg-v5-backgrounds';
      wrap.innerHTML = '<strong class="mg-v5-mini-label">Hintergrund</strong><div class="mg-v5-background-grid"></div>';
      body.append(wrap);
      safeHideNative(field, form);
    }

    section.append(body);
    panel.append(section);
    window.setTimeout(() => {
      const liveForm = currentForm() || form;
      refreshBackgroundGrid(liveForm, selectedDesignIndex(liveForm));
    }, 0);
  }

  function textClickable(root, needle) {
    const wanted = norm(needle);
    const candidates = Array.from(root?.querySelectorAll('button, label, [role="option"], [role="radio"], [role="button"], li, a') || []);
    return candidates.find((el) => {
      const value = norm(el.getAttribute('data-value') || el.getAttribute('title') || el.textContent || '');
      return value === wanted || value.includes(wanted);
    }) || null;
  }

  function markFontSelected(proxyButton) {
    proxyButton.closest('.mg-v5-font-grid')?.querySelectorAll('.mg-v5-font').forEach((item) => item.classList.remove('is-selected'));
    proxyButton.classList.add('is-selected');
  }

  function fontControlValue(control) {
    if (!control) return '';
    const label = control instanceof HTMLInputElement ? labelFor(control) : null;
    return norm([
      control.value,
      control.getAttribute?.('data-value'),
      control.getAttribute?.('data-title'),
      control.getAttribute?.('title'),
      control.getAttribute?.('aria-label'),
      label?.getAttribute?.('data-title'),
      label?.getAttribute?.('title'),
      label?.textContent,
      control.textContent
    ].filter(Boolean).join(' '));
  }

  function fontControlsForSelector(selector) {
    const form = currentForm();
    const editable = currentEditable(selector);
    if (!form || !editable) return [];
    const field = nativeField(editable) || currentField(selector).field;
    const local = Array.from(field?.querySelectorAll('input, select') || []).filter((control) => {
      const meta = norm(`${control.name || ''} ${control.id || ''} ${control.className || ''} ${control.getAttribute?.('aria-label') || ''}`);
      return /font|schrift/.test(meta);
    });
    if (local.length) return local;

    const controls = Array.from(form.querySelectorAll('input, textarea, select'));
    const index = controls.indexOf(editable);
    if (index < 0) return [];
    const result = [];
    for (let i = index + 1; i < controls.length; i += 1) {
      const control = controls[i];
      const meta = norm(`${control.name || ''} ${control.id || ''} ${control.className || ''} ${control.getAttribute?.('aria-label') || ''}`);
      const isFont = /font|schrift/.test(meta);
      if (isFont) {
        result.push(control);
        continue;
      }
      if (control.matches('textarea, input[type="text"]')) break;
    }
    return result;
  }

  function chooseFont(selector, font, proxyButton) {
    const { field } = currentField(selector);
    if (!field) return;
    const wantedName = norm(font.raw);
    const wantedId = String(font.id || '');
    const nativeControls = fontControlsForSelector(selector);

    for (const control of nativeControls) {
      if (control instanceof HTMLSelectElement) {
        const option = Array.from(control.options).find((item) => {
          const value = norm(`${item.value || ''} ${item.textContent || ''}`);
          return value.includes(wantedName) || (wantedId && String(item.value || '').includes(wantedId));
        });
        if (option) {
          control.value = option.value;
          control.dispatchEvent(new Event('input', { bubbles: true }));
          control.dispatchEvent(new Event('change', { bubbles: true }));
          markFontSelected(proxyButton);
          scheduleSync();
          return;
        }
      } else {
        const value = fontControlValue(control);
        if (value.includes(wantedName) || (wantedId && value.includes(wantedId))) {
          clickNative(control);
          markFontSelected(proxyButton);
          scheduleSync();
          return;
        }
      }
    }

    const direct = textClickable(field, font.raw);
    if (direct) {
      clickNative(direct);
      markFontSelected(proxyButton);
      scheduleSync();
      return;
    }

    const opener = Array.from(field.querySelectorAll('button, [role="button"], select, [class*="font"]'))
      .find((el) => /schriftart|font/i.test(clean(el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || el.className)));
    if (!opener) return;
    clickNative(opener);

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      const popupRoots = Array.from(document.querySelectorAll('.tee-dialog, [role="dialog"], [role="listbox"], .vm--container, [class*="popover"], [class*="dropdown"]'));
      const target = popupRoots.map((root) => textClickable(root, font.raw)).find(Boolean) || textClickable(document.body, font.raw);
      if (target) {
        window.clearInterval(timer);
        clickNative(target);
        markFontSelected(proxyButton);
        scheduleSync();
      } else if (tries >= 15) {
        window.clearInterval(timer);
      }
    }, 80);
  }

  function fontSignature(value) {
    return norm(value).replace(/regular|variablefont|wght|font|schriftart|schrift/g, '').replace(/[^a-z0-9]/g, '');
  }

  function fontChoiceFromValue(value) {
    const raw = String(value || '');
    const normalized = norm(raw);
    const signature = fontSignature(raw);
    return FONT_CHOICES.find((font) => {
      const fontRaw = norm(font.raw);
      const fontSig = fontSignature(font.raw);
      const thumbKey = String(font.thumb || '').split('/').pop()?.replace(/_thumbnail\.webp.*$/i, '') || '';
      return normalized.includes(fontRaw)
        || raw.includes(String(font.id || ''))
        || (fontSig && signature.includes(fontSig))
        || (thumbKey && raw.includes(thumbKey));
    }) || null;
  }

  function selectedFontChoice(selector) {
    const editable = currentEditable(selector);
    const { field } = currentField(selector);
    if (!editable || !field) return null;

    const controls = Array.from(new Set([
      ...fontControlsForSelector(selector),
      ...Array.from(field.querySelectorAll('input, select, [aria-selected="true"], [aria-checked="true"], .is-selected, .selected, .active'))
    ]));
    for (const control of controls) {
      if (control instanceof HTMLSelectElement) {
        const option = control.selectedOptions?.[0];
        const match = fontChoiceFromValue(`${control.value || ''} ${option?.value || ''} ${option?.textContent || ''}`);
        if (match) return match;
        continue;
      }
      if (control instanceof HTMLInputElement && ['radio', 'checkbox'].includes(control.type) && !control.checked) continue;
      const match = fontChoiceFromValue(`${fontControlValue(control)} ${control instanceof HTMLElement ? control.innerHTML : ''}`);
      if (match) return match;
    }

    const hiddenValues = Array.from(field.querySelectorAll('input[type="hidden"], [data-font], [data-font-family], [data-font-id]'))
      .map((node) => `${node.value || ''} ${node.getAttribute?.('data-font') || ''} ${node.getAttribute?.('data-font-family') || ''} ${node.getAttribute?.('data-font-id') || ''}`)
      .join(' ');
    const hiddenMatch = fontChoiceFromValue(hiddenValues);
    if (hiddenMatch) return hiddenMatch;

    const computed = window.getComputedStyle?.(editable);
    const styleMatch = fontChoiceFromValue(`${editable.style?.fontFamily || ''} ${computed?.fontFamily || ''}`);
    if (styleMatch) return styleMatch;

    return null;
  }

  function syncFontPickers() {
    document.querySelectorAll('.mg-v5-font-picker[data-font-selector]').forEach((picker) => {
      const selector = picker.dataset.fontSelector || '';
      const selected = selectedFontChoice(selector);
      picker.querySelectorAll('.mg-v5-font').forEach((button) => {
        const active = Boolean(selected) && button.dataset.fontId === String(selected.id || '');
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function addFontPicker(wrap, selector, field) {
    if (!field) return;
    const picker = document.createElement('div');
    picker.className = 'mg-v5-font-picker';
    picker.dataset.fontSelector = selector;
    picker.innerHTML = '<span class="mg-v5-font-label">Schriftart</span><div class="mg-v5-font-grid"></div>';
    const grid = picker.querySelector('.mg-v5-font-grid');
    FONT_CHOICES.forEach((font) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mg-v5-font';
      button.dataset.fontId = String(font.id || '');
      button.dataset.fontName = font.raw;
      button.setAttribute('aria-label', 'Schriftart auswählen');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = `<img src="${escapeHtml(font.thumb)}" alt="" loading="lazy">`;
      button.addEventListener('click', () => chooseFont(selector, font, button));
      grid.append(button);
    });
    wrap.append(picker);
    window.setTimeout(syncFontPickers, 0);
  }

  function createSyncedTextControl(panelBody, form, selector, title, placeholder, multiline = false, withFonts = true) {
    const anchor = scopedQuery(form, selector);
    if (!anchor) return false;
    const field = nativeField(anchor);
    const initialNative = findEditableText(field, anchor);
    if (!initialNative) return false;

    const wrap = document.createElement('div');
    wrap.className = 'mg-v5-control';
    const label = document.createElement('label');
    label.className = 'mg-v5-control-label';
    label.textContent = title;
    const input = multiline ? document.createElement('textarea') : document.createElement('input');
    if (!multiline) input.type = 'text';
    input.placeholder = placeholder || '';
    input.value = initialNative.value || '';
    input.className = 'mg-v5-text-input';
    if (multiline) input.rows = 3;
    input.addEventListener('input', () => {
      const current = currentEditable(selector) || initialNative;
      setNativeValue(current, input.value);
    });
    wrap.append(label, input);
    if (withFonts) addFontPicker(wrap, selector, field);
    panelBody.append(wrap);
    safeHideNative(field, form);
    return true;
  }

  function buildText(panel, form) {
    const section = createSection('Persönliche Angaben', 'Name, Lebensdaten und deine persönlichen Worte.', 'mg-v5-text-section');
    const body = document.createElement('div');
    body.className = 'mg-v5-text-grid';
    let count = 0;
    count += createSyncedTextControl(body, form, '.mg-name, .mg-name-anchor', 'Name', 'Name eingeben …') ? 1 : 0;
    count += createSyncedTextControl(body, form, '.mg-datum, .mg-datum-anchor', 'Lebensdaten', 'z. B. 12.03.1942 – 04.08.2026') ? 1 : 0;
    count += createSyncedTextControl(body, form, '.mg-widmung-mensch, .mg-spruch:not(.mg-spruch-anchor)', 'Widmung', 'Persönliche Worte eingeben …', true) ? 1 : 0;
    if (!count) return;
    section.append(body);
    panel.append(section);
  }

  function sizeKey(value) {
    const match = clean(value).match(/(\d+)\s*[x×]\s*(\d+)/i);
    if (match) return `${Number(match[1])}x${Number(match[2])}`;
    return norm(value || '').replace(/\s+/g, '');
  }

  function isSaleSizeKey(value) {
    const key = sizeKey(value);
    return key === '40x30' || key === '30x40';
  }

  function radioLooksSelected(input) {
    if (!input) return false;
    if (input.checked) return true;
    if (input.getAttribute('aria-checked') === 'true') return true;
    if (input.dataset?.selected === 'true' || input.dataset?.checked === 'true') return true;
    const nodes = [labelFor(input), input.parentElement, input.closest('[class]')].filter(Boolean);
    return nodes.some((node) => {
      const classes = Array.from(node.classList || []).map((name) => norm(name));
      return classes.some((name) => /(^|[-_])(selected|active|checked|current)([-_]|$)/.test(name));
    });
  }

  function selectedRadio(group) {
    if (!group) return null;
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    return radios.find((input) => input.checked) || radios.find(radioLooksSelected) || null;
  }

  function currentNativeSize() {
    const group = findRadioGroup(['größe', 'groesse', 'size', 'format'], 2, ['schrift']);
    if (!group) return '';
    const selected = selectedRadio(group);
    if (!selected) return '';
    return sizeKey(labelFor(selected)?.textContent || selected.value || '');
  }

  function currentNativeFinish() {
    const group = document.querySelector('#tee-field--teeinblue-available-prod') || findRadioGroup(['available product', 'ausführung', 'ausfuehrung', 'qualität', 'qualitaet'], 2);
    if (!group) return '';
    const selected = selectedRadio(group);
    if (!selected) return '';
    return finishName(labelFor(selected)?.textContent || selected.value || '');
  }

  function markVariantState() {
    document.querySelectorAll('.mg-v5-size-grid').forEach((grid) => {
      grid.querySelectorAll('.mg-v5-size').forEach((button) => {
        const selected = !!variantState.size && button.dataset.sizeKey === variantState.size;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
    document.querySelectorAll('.mg-v5-finish-tabs').forEach((tabs) => {
      tabs.querySelectorAll('.mg-v5-finish-tab').forEach((button) => {
        const selected = !!variantState.finish && button.dataset.finishName === variantState.finish;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
  }

  // MG: gemeinsame Wertanzeige (Flaeche und Farbbrillanz-Zeitraum).
  const mgValueEuro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const mgValueNumber = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function mgParseEuro(raw) {
    const match = String(raw || '').match(/(\d{1,5}(?:\.\d{3})*(?:,\d{1,2})?|\d{1,5}(?:\.\d{1,2})?)\s*€/);
    if (!match) return NaN;
    let value = match[1];
    if (value.includes(',')) value = value.replace(/\./g, '').replace(',', '.');
    return Number(value);
  }

  function mgGetArea(size) {
    const match = sizeKey(size).match(/^(\d+)x(\d+)$/);
    return match ? Number(match[1]) * Number(match[2]) : 0;
  }

  function mgInstallValueStyles() {
    if (document.getElementById('mg-value-summary-style')) return;
    const style = document.createElement('style');
    style.id = 'mg-value-summary-style';
    style.textContent = `
      .mg-value-summary{margin-top:16px;padding:16px;border:1px solid #e7e0dd;background:#fff;border-radius:12px;box-sizing:border-box;color:#292421}
      .mg-value-summary[hidden]{display:none!important}
      .mg-value-top{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:12px}
      .mg-value-title{font-size:14px;font-weight:700;letter-spacing:.01em}
      .mg-value-heart{color:#700404;font-size:20px;line-height:1}
      .mg-value-tiles{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px}
      .mg-value-tile{padding:13px 10px;background:#f7f5f4;border-radius:9px;min-width:0}
      .mg-value-number{font-weight:750;font-size:clamp(17px,2vw,23px);line-height:1.2;color:#700404;font-variant-numeric:tabular-nums}
      .mg-value-caption{font-size:12px;color:#625d5a;margin-top:5px;line-height:1.4}
      .mg-value-description{font-size:12px;line-height:1.55;color:#625d5a;margin-top:11px}
      @media(max-width:360px){.mg-value-summary{padding:12px}.mg-value-tile{padding:10px 8px}.mg-value-number{font-size:17px}}
    `;
    document.head.append(style);
  }

  function mgBuildValueSummary(parent) {
    mgInstallValueStyles();
    const block = document.createElement('div');
    block.className = 'mg-value-summary';
    block.hidden = true;
    block.setAttribute('aria-label', 'Preis und Wert deiner Gedenktafel');
    block.innerHTML = `
      <div class="mg-value-top"><span class="mg-value-title">Der Wert deiner Gedenktafel</span><span class="mg-value-heart" aria-hidden="true">♡</span></div>
      <div class="mg-value-tiles">
        <div class="mg-value-tile"><div class="mg-value-number" data-mg-value-area></div><div class="mg-value-caption">pro cm² Tafelfläche</div></div>
        <div class="mg-value-tile"><div class="mg-value-number" data-mg-value-month></div><div class="mg-value-caption">pro Monat umgerechnet</div></div>
      </div>
      <div class="mg-value-description" data-mg-value-note></div>
    `;
    parent.append(block);
  }

  function mgSyncValueSummary(form, root, priceText) {
    const block = form?.querySelector('.mg-value-summary');
    if (!block) return;
    const total = mgParseEuro(priceText);
    const area = mgGetArea(variantState.size || currentNativeSize());
    const valid = !variantState.transition && Number.isFinite(total) && total > 0 && area > 0;
    block.hidden = !valid;
    if (!valid) return;
    const finish = variantState.finish || currentNativeFinish();
    const standard = finish === 'Standard';
    const months = standard ? 36 : 84;
    const years = standard ? 'ca. 3 Jahren' : 'mindestens 7 Jahren';
    const areaNode = block.querySelector('[data-mg-value-area]');
    const monthNode = block.querySelector('[data-mg-value-month]');
    const noteNode = block.querySelector('[data-mg-value-note]');
    const centsText = mgValueNumber.format(total * 100 / area) + ' ct';
    const monthText = mgValueEuro.format(total / months);
    const noteText = 'Die Monatsangabe verteilt den einmaligen Kaufpreis rechnerisch auf ' + years + ' Farbbrillanz im Außenbereich. Sie ist kein Abo, keine Ratenzahlung und keine Angabe zur Lebensdauer der Tafel.';
    if (areaNode.textContent !== centsText) areaNode.textContent = centsText;
    if (monthNode.textContent !== monthText) monthNode.textContent = monthText;
    if (noteNode.textContent !== noteText) noteNode.textContent = noteText;
  }

  function buildSizes(panel, form) {
    const group = findRadioGroup(['größe', 'groesse', 'size', 'format'], 2, ['schrift']);
    if (!group) return;
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;
    const block = document.createElement('div');
    block.className = 'mg-v5-compact-block';
    block.innerHTML = '<div class="mg-v5-inline-head"><strong>Größe</strong><span>Wähle das passende Format</span></div><div class="mg-v5-size-grid"></div>';
    const grid = block.querySelector('.mg-v5-size-grid');
    const initiallySelected = selectedRadio(group) || radios[0];
    if (!variantState.size && initiallySelected) {
      variantState.size = sizeKey(labelFor(initiallySelected)?.textContent || initiallySelected.value || '');
    }
    radios.forEach((input) => {
      const labelText = clean(labelFor(input)?.textContent || input.value);
      const sizeText = labelText.match(/\d+\s*[x×]\s*\d+\s*(?:cm)?/i)?.[0] || labelText;
      const price = extractPrice(labelText.replace(sizeText, ''));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mg-v5-size';
      button.dataset.nativeId = input.id || '';
      button.dataset.sizeKey = sizeKey(sizeText);
      const isSaleSize = isSaleSizeKey(sizeText);
      button.innerHTML = `${isSaleSize ? '<span class="mg-v5-sale-badge">Im Angebot</span>' : ''}<span>${escapeHtml(sizeText.replace(/\s*x\s*/gi, ' × '))}</span>${price ? `<small>${escapeHtml(price)}</small>` : ''}`;
      button.addEventListener('click', () => {
        const wantedSize = button.dataset.sizeKey;
        variantState.size = wantedSize;
        variantState.transition = true;
        const token = ++variantState.transitionToken;
        markVariantState();
        const freshInput = currentRadioByLabel(['größe', 'groesse', 'size', 'format'], ['schrift'], labelText, button.dataset.nativeId);
        clickNative(freshInput || input);
        let attempts = 0;
        const confirm = () => {
          if (token !== variantState.transitionToken) return;
          attempts += 1;
          const nativeSize = currentNativeSize();
          if (nativeSize === wantedSize || attempts >= 12) {
            variantState.size = wantedSize;
            variantState.transition = false;
            markVariantState();
            scheduleSync();
            return;
          }
          window.setTimeout(confirm, attempts < 5 ? 70 : 120);
        };
        window.setTimeout(confirm, 50);
      });
      grid.append(button);
    });
    panel.append(block);
    safeHideNative(group, form);
  }


  function restoreSizeAfterFinish(sizeValue, previousGroup, token) {
    const wanted = sizeKey(sizeValue);
    if (!wanted) {
      variantState.transition = false;
      scheduleSync();
      return;
    }
    let attempts = 0;
    const tryRestore = () => {
      if (token !== variantState.transitionToken) return;
      attempts += 1;
      const group = findRadioGroup(['größe', 'groesse', 'size', 'format'], 2, ['schrift']);
      const groupReady = group && (!previousGroup || !previousGroup.isConnected || group !== previousGroup || attempts >= 4);
      if (groupReady) {
        const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((candidate) => {
          return sizeKey(labelFor(candidate)?.textContent || candidate.value || '') === wanted;
        });
        if (radio) {
          if (!radio.checked) clickNative(radio);
          variantState.size = wanted;
          window.setTimeout(() => {
            if (token !== variantState.transitionToken) return;
            const nativeSize = currentNativeSize();
            if (nativeSize) variantState.size = nativeSize;
            variantState.transition = false;
            markVariantState();
            scheduleSync();
          }, 140);
          return;
        }
      }
      if (attempts < 14) {
        window.setTimeout(tryRestore, attempts < 5 ? 90 : 150);
      } else {
        const nativeSize = currentNativeSize();
        if (nativeSize) variantState.size = nativeSize;
        variantState.transition = false;
        markVariantState();
        scheduleSync();
      }
    };
    window.setTimeout(tryRestore, 70);
  }

  function finishName(value) {
    const n = norm(value);
    if (n.includes('premium plus')) return 'Premium Plus';
    if (n.includes('premium')) return 'Premium';
    return 'Standard';
  }

  function buildFinish(panel, form) {
    const group = document.querySelector('#tee-field--teeinblue-available-prod') || findRadioGroup(['available product', 'ausführung', 'ausfuehrung', 'qualität', 'qualitaet'], 2);
    if (!group) return;
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (radios.length < 2) return;

    const data = {
      'Standard': '3 mm · UV-Direktdruck · ca. 3 Jahre Farbbrillanz außen',
      'Premium': '3 mm · UV-Schutzlaminat · mindestens 7 Jahre Farbbrillanz außen',
      'Premium Plus': '6 mm · UV-Schutzlaminat · mindestens 7 Jahre Farbbrillanz außen'
    };
    const block = document.createElement('div');
    block.className = 'mg-v5-compact-block mg-v5-finish-block';
    block.innerHTML = '<div class="mg-v5-inline-head"><strong>Ausführung</strong><span>Alle Varianten sind wetterfest</span></div><div class="mg-v5-finish-tabs"></div><div class="mg-v5-finish-info" aria-live="polite"></div>';
    const tabs = block.querySelector('.mg-v5-finish-tabs');
    const initiallySelected = selectedRadio(group) || radios[0];
    if (!variantState.finish && initiallySelected) {
      variantState.finish = finishName(labelFor(initiallySelected)?.textContent || initiallySelected.value || '');
    }
    radios.forEach((input) => {
      const raw = clean(labelFor(input)?.textContent || input.value);
      const name = finishName(raw);
      const price = extractPrice(raw.replace(name, ''));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `mg-v5-finish-tab ${name === 'Premium' ? 'is-recommended' : ''}`;
      button.dataset.nativeId = input.id || '';
      button.dataset.finishName = name;
      button.innerHTML = `<span>${escapeHtml(name)}</span>${name === 'Premium' ? '<small>Empfohlen</small>' : ''}${price ? `<em>${escapeHtml(price)}</em>` : ''}`;
      button.addEventListener('click', () => {
        const selectedSize = variantState.size || currentNativeSize();
        const previousSizeGroup = findRadioGroup(['größe', 'groesse', 'size', 'format'], 2, ['schrift']);
        variantState.finish = name;
        variantState.transition = true;
        const token = ++variantState.transitionToken;
        markVariantState();
        const freshInput = currentFinishRadio(raw, button.dataset.nativeId);
        clickNative(freshInput || input);
        restoreSizeAfterFinish(selectedSize, previousSizeGroup, token);
      });
      tabs.append(button);
    });
    block.dataset.finishMap = JSON.stringify(data);
    panel.append(block);
    safeHideNative(group, form);
  }

  function buildExtras(panel, form) {
    const section = createSection('Optional', '', 'mg-v5-extras');
    const body = document.createElement('div');
    body.className = 'mg-v5-extras-grid';
    let count = 0;

    const wishAnchor = scopedQuery(form, '.mg-anmerkung, .mg-anmerkung-anchor');
    if (wishAnchor) {
      const field = nativeField(wishAnchor);
      const native = field?.querySelector('textarea, input[type="text"]');
      if (native) {
        const label = document.createElement('label');
        label.className = 'mg-v5-control mg-v5-wishes';
        label.innerHTML = '<span class="mg-v5-control-label">Individuelle Wünsche</span><span class="mg-v5-control-note">Optional – besondere Anpassungen kannst du uns hier mitteilen.</span>';
        const textarea = document.createElement('textarea');
        textarea.className = 'mg-v5-text-input';
        textarea.rows = 3;
        textarea.placeholder = 'Was dürfen wir für dich anpassen?';
        textarea.value = native.value || '';
        textarea.addEventListener('input', () => {
          setNativeValue(native, textarea.value);
        });
        label.append(textarea);
        body.append(label);
        safeHideNative(field, form);
        count++;
      }
    }

    if (!count) return;
    section.append(body);
    panel.append(section);
  }

  function nativeExtraTitle(node) {
    const direct = Array.from(node.children || []).find((child) => child.matches?.('.tee-form-label, .tee-label, .tee-field-label, legend, [class*="label"]'));
    const candidate = direct || node.querySelector('.tee-form-label, .tee-label, .tee-field-label, legend, [class*="label"]');
    return clean(candidate?.textContent || node.getAttribute('data-label') || node.getAttribute('aria-label') || '');
  }

  function nativeExtraKind(node) {
    const title = norm(nativeExtraTitle(node));
    const text = norm(`${title} ${node.getAttribute('data-name') || ''} ${node.id || ''} ${node.className || ''}`);
    if (/design|stil|style|motiv/.test(text)) return 'design';
    if (/bild\s*\/?\s*grafik|foto|photo|grafik|graphic|bild/.test(text)) return 'media';
    if (/widmung|spruch|text|name|datum|person/.test(text)) return 'text';
    return 'option';
  }

  function insertNativeSection(panel, section, kind) {
    let reference = null;
    if (kind === 'design') {
      reference = panel.querySelector('.mg-v5-photo-section, .mg-v5-text-section, .mg-v5-choice-section');
    } else if (kind === 'media') {
      reference = panel.querySelector('.mg-v5-text-section, .mg-v5-choice-section');
    } else {
      reference = panel.querySelector('.mg-v5-choice-section, .mg-v5-extras, .mg-v5-purchase');
    }
    if (reference) panel.insertBefore(section, reference);
    else panel.append(section);
  }

  function buildNativeFallback(panel, form) {
    const selector = '.tee-form-input, .tee-field, .tee-form-group, .tee-input-group, .tee-input-container';
    const candidates = Array.from(form.querySelectorAll(selector)).filter((node) => {
      if (!(node instanceof HTMLElement)) return false;
      if (node.closest('.mg-v5-panel')) return false;
      if (node.classList.contains('mg-v5-proxied') || node.closest('.mg-v5-proxied') || node.querySelector('.mg-v5-proxied')) return false;
      if (node.closest('.tee-variants, .tee-form-actions, #tee-field--teeinblue-available-prod')) return false;
      if (node.matches('.tee-variants, .tee-form-actions, #tee-field--teeinblue-available-prod')) return false;
      if (!node.querySelector('input, textarea, select, button, [role="button"], [role="radio"], [role="option"]')) return false;
      return true;
    });
    const topLevel = candidates.filter((node) => !candidates.some((other) => other !== node && other.contains(node)));
    if (!topLevel.length) return;

    topLevel.forEach((node) => {
      const kind = nativeExtraKind(node);
      const section = document.createElement('section');
      section.className = `mg-v5-section mg-v5-native-integrated mg-v5-native-${kind}`;
      const body = document.createElement('div');
      body.className = 'mg-v5-native-integrated-body';
      node.classList.remove(NATIVE_HIDDEN, 'mg-v5-proxied');
      node.classList.add('mg-v5-native-extra');
      body.append(node);
      section.append(body);
      insertNativeSection(panel, section, kind);
    });
  }

  function fieldTitle(node) {
    if (!node) return '';
    const direct = Array.from(node.children || []).find((child) => child.matches?.('.tee-form-label, .tee-label, .tee-field-label, legend, h2, h3, h4, [class*=\"label\"], [class*=\"title\"]'));
    const candidate = direct || node.querySelector('.tee-form-label, .tee-label, .tee-field-label, legend, h2, h3, h4, [class*=\"label\"], [class*=\"title\"]');
    return clean(candidate?.textContent || node.getAttribute('data-label') || node.getAttribute('aria-label') || '');
  }

  function fieldMeta(node) {
    const mgClasses = Array.from(node.querySelectorAll('[class*=\"mg-\"]')).slice(0, 20).map((el) => el.className || '').join(' ');
    return norm([fieldTitle(node), node.id || '', node.className || '', mgClasses].join(' '));
  }

  function classifyNativeField(node) {
    const meta = fieldMeta(node);
    if (/mg-design|design waehlen|design wählen|\bdesign\b|\bstil\b|\bstyle\b|\bmotiv\b/.test(meta)) return 'design';
    if (/mg-bild|mg-hintergrund|mg-grafik|bild\s*\/?\s*grafik|foto|photo|upload|hintergrund|grafik|graphic|bildoptim/.test(meta)) return 'media';
    if (/mg-name|mg-datum|mg-person|mg-widmung|mg-spruch|\bname\b|datum|lebensdaten|widmung|spruch|person/.test(meta)) return 'personal';
    return 'option';
  }

  function fieldOrder(node, kind) {
    const meta = fieldMeta(node);
    if (kind === 'design') return 10;
    if (kind === 'media') {
      if (/bild\s*\/?\s*grafik|mit bild|ohne bild/.test(meta)) return 10;
      if (/foto|photo|upload|mg-bild/.test(meta)) return 20;
      if (/bildoptim/.test(meta)) return 30;
      if (/hintergrund|mg-hintergrund/.test(meta)) return 40;
      if (/grafik|graphic/.test(meta)) return 50;
      return 60;
    }
    if (kind === 'personal') {
      if (/name|mg-person/.test(meta)) return 10;
      if (/datum|lebensdaten/.test(meta)) return 20;
      if (/widmung option|spruch option|vordefiniert/.test(meta)) return 30;
      if (/widmung/.test(meta)) return 40;
      if (/spruch/.test(meta)) return 50;
      return 60;
    }
    if (/qualitaetscheck|qualitätscheck|service|gestaltungsservice/.test(meta)) return 20;
    if (/anmerkung|wuensch|wünsch/.test(meta)) return 80;
    return 50;
  }

  function fieldHasChoices(node) {
    return node.querySelectorAll('input[type=\"radio\"], input[type=\"checkbox\"], [role=\"radio\"], [role=\"option\"], button').length > 0;
  }

  function fieldHasImages(node) {
    return node.querySelectorAll('img, picture, [style*=\"background-image\"], [class*=\"thumbnail\"], [class*=\"clipart\"]').length > 1;
  }

  function markNativeField(node, kind) {
    const meta = fieldMeta(node);
    node.classList.add('mg-v6-native-field', 'mg-v6-' + kind + '-field');
    node.style.setProperty('--mg-v6-order', String(fieldOrder(node, kind)));
    if (kind === 'design' || /hintergrund|grafik|motiv/.test(meta) || (kind === 'media' && fieldHasImages(node))) node.classList.add('mg-v6-image-choice');
    if (/foto|photo|upload|mg-bild/.test(meta)) node.classList.add('mg-v6-upload-field');
    if (kind === 'design' && /design waehlen|design wählen|^design$/.test(norm(fieldTitle(node)))) node.classList.add('mg-v6-hide-native-title');
  }

  function originFor(field) {
    let marker = movedOrigins.get(field);
    if (marker?.isConnected) return marker;
    marker = document.createElement('span');
    marker.className = 'mg-v6-origin';
    marker.hidden = true;
    field.before(marker);
    movedOrigins.set(field, marker);
    return marker;
  }

  function nativeCandidates(form, panel) {
    const selector = '.tee-form-input, .tee-field, .tee-form-group, .tee-input-group, .tee-input-container, .tee-block';
    const raw = Array.from(form.querySelectorAll(selector)).filter((node) => {
      if (!(node instanceof HTMLElement)) return false;
      if (node.closest('.mg-v5-panel') && !panel.contains(node)) return false;
      if (panel.contains(node)) return false;
      if (node.closest('.tee-variants, .tee-form-actions, #tee-field--teeinblue-available-prod')) return false;
      if (node.matches('.tee-variants, .tee-form-actions, #tee-field--teeinblue-available-prod')) return false;
      if (node.matches('script, style, template, .tee-dialog, [role=\"dialog\"], [role=\"listbox\"]')) return false;
      if (!node.querySelector('input, textarea, select, button, [role=\"button\"], [role=\"radio\"], [role=\"option\"]')) return false;
      return true;
    });
    raw.sort((a, b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length);
    const picked = [];
    for (const node of raw) {
      if (picked.some((small) => node.contains(small))) continue;
      picked.push(node);
    }
    const designGroup = findRadioGroup(['design wählen','design waehlen','design','stil','style','motiv'], 2, ['größe','groesse','size','available product']);
    if (designGroup && !panel.contains(designGroup)) {
      for (let index = picked.length - 1; index >= 0; index--) {
        if (designGroup.contains(picked[index])) picked.splice(index, 1);
      }
      if (!picked.includes(designGroup)) picked.unshift(designGroup);
    }
    return picked;
  }

  function ensureNativeGroups(panel) {
    const defs = [
      ['design','Design auswählen','Wähle das passende Design.'],
      ['media','Bild & Gestaltung','Foto, Grafik und Hintergrund.'],
      ['personal','Persönliche Angaben','Name, Lebensdaten und persönliche Worte.'],
      ['option','Weitere Optionen','Zusätzliche Möglichkeiten für deine Gestaltung.']
    ];
    const result = {};
    for (const [kind,title,subtitle] of defs) {
      let section = panel.querySelector('.mg-v6-group-' + kind);
      if (!section) {
        section = createSection(title, subtitle, 'mg-v6-native-group mg-v6-group-' + kind);
        const body = document.createElement('div');
        body.className = 'mg-v6-native-body';
        section.append(body);
        panel.append(section);
      }
      result[kind] = section.querySelector('.mg-v6-native-body');
    }
    return result;
  }

  function placeNativeGroups(panel) {
    const design = panel.querySelector('.mg-v6-group-design');
    const media = panel.querySelector('.mg-v6-group-media');
    const personal = panel.querySelector('.mg-v6-group-personal');
    const option = panel.querySelector('.mg-v6-group-option');
    const choices = panel.querySelector('.mg-v5-choice-section');
    const purchase = panel.querySelector('.mg-v5-purchase');
    [design, media, personal, option].forEach((section) => {
      if (!section) return;
      const hasVisible = Array.from(section.querySelectorAll(':scope > .mg-v6-native-body > .mg-v6-native-field')).some((field) => field.isConnected);
      section.hidden = !hasVisible;
    });
    if (design) panel.insertBefore(design, panel.children[1] || null);
    if (media) panel.insertBefore(media, personal || choices || purchase || null);
    if (personal) panel.insertBefore(personal, option || choices || purchase || null);
    if (option) panel.insertBefore(option, choices || purchase || null);
  }

  function integrateNativeFields(panel, form) {
    const groups = ensureNativeGroups(panel);
    nativeCandidates(form, panel).forEach((field) => {
      if (field.classList.contains(NATIVE_HIDDEN) || field.closest('.' + NATIVE_HIDDEN)) return;
      const kind = classifyNativeField(field);
      originFor(field);
      markNativeField(field, kind);
      groups[kind].append(field);
    });
    placeNativeGroups(panel);
  }

  function buildPurchase(panel, form) {
    const actions = form?.querySelector('.tee-form-actions');
    if (!actions) return;
    const nativeCart = Array.from(actions.querySelectorAll('button')).find((button) => /warenkorb|cart|bestellen/i.test(clean(button.textContent))) || actions.querySelector('button[type="submit"]');
    if (!nativeCart) return;

    const box = document.createElement('div');
    box.className = 'mg-v5-purchase';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mg-v5-cart-button';
    button.innerHTML = '<span>Gedenktafel in den Warenkorb</span><span aria-hidden="true">→</span>';
    button.addEventListener('click', () => {
      const liveForm = currentForm() || form;
      const liveActions = liveForm?.querySelector('.tee-form-actions');
      const liveCart = Array.from(liveActions?.querySelectorAll('button') || []).find((entry) => /warenkorb|cart|bestellen/i.test(clean(entry.textContent))) || liveActions?.querySelector('button[type="submit"]') || nativeCart;
      window.setTimeout(() => liveCart?.click?.(), 30);
    });
    box.append(button);

    const draft = document.querySelector('#mg-draft-save-root .mg-draft-save__open');
    if (draft) {
      const save = document.createElement('button');
      save.type = 'button';
      save.className = 'mg-v5-save-button';
      save.innerHTML = '<span aria-hidden="true">♡</span><span>Entwurf für später speichern</span>';
      save.addEventListener('click', () => draft.click());
      box.append(save);
    }

    const trust = document.createElement('div');
    trust.className = 'mg-v5-purchase-trust';
    trust.innerHTML = '<span>✓ Live-Vorschau</span><span>✓ Wir prüfen deine Gestaltung</span><span>✓ Persönlicher Service</span>';
    box.append(trust);

    const meta = document.createElement('div');
    meta.className = 'mg-v5-purchase-meta';

    const shipping = document.createElement('div');
    shipping.className = 'mg-v5-purchase-info mg-v5-purchase-shipping';
    shipping.innerHTML = '<div class="mg-v5-info-icon" aria-hidden="true">✓</div><div class="mg-v5-info-copy"><strong>In 5–10 Werktagen (Mo-Fr) bei dir</strong><span>3,99 € Versand · ab 99 € versandkostenfrei in Deutschland</span></div>';
    meta.append(shipping);

    const payments = document.createElement('div');
    payments.className = 'mg-v5-purchase-info mg-v5-purchase-payments';
    const paymentCopy = document.createElement('div');
    paymentCopy.className = 'mg-v5-info-copy';
    paymentCopy.innerHTML = '<strong>Sicher & flexibel bezahlen</strong>';
    const badges = document.createElement('div');
    badges.className = 'mg-v5-payment-badges';
    badges.setAttribute('aria-label', 'PayPal, Klarna, Visa, Mastercard, American Express und SEPA');
    const logoTemplate = document.querySelector('[id^="mg-v5-payment-logos-template-"]');
    if (logoTemplate?.content) {
      badges.append(logoTemplate.content.cloneNode(true));
    }
    paymentCopy.append(badges);
    payments.append(paymentCopy);
    meta.append(payments);

    box.append(meta);

    panel.append(box);

    const draftRoot = document.getElementById('mg-draft-save-root');
    Array.from(actions.children).forEach((child) => {
      if (child === draftRoot || child.contains?.(draftRoot)) return;
      safeHideNative(child, form);
    });
    if (draft) safeHideNative(draft, form);
  }

  function readCurrentPrice(form, root) {
    const scopes = [form, root, document];
    const selectors = [
      '.tee-price--current', '.tee-product-price', '.tee-price', '[class*="product-price"]', '[class*="tee-price"]',
      '[id*="price"] .price-item--regular', '.price-item--regular', '[class*="price"]'
    ];
    for (const scope of scopes) {
      if (!scope) continue;
      for (const selector of selectors) {
        for (const node of scope.querySelectorAll(selector)) {
          if (node.closest('.mg-v5-panel')) continue;
          const text = clean(node.textContent);
          const match = text.match(/\d{1,4}(?:[.,]\d{2})\s*€/);
          if (match) return match[0];
        }
      }
    }
    return '';
  }

  function sync(root, form) {
    if (!variantState.transition) {
      const nativeSize = currentNativeSize();
      if (nativeSize) variantState.size = nativeSize;
      if (!variantState.finish) {
        const nativeFinish = currentNativeFinish();
        if (nativeFinish) variantState.finish = nativeFinish;
      }
    }
    markVariantState();
    if (variantState.transition) {
      form?.querySelectorAll('.mg-value-summary').forEach((node) => { node.hidden = true; });
    }
    document.querySelectorAll('.mg-v5-finish-block').forEach((block) => {
      let map = {};
      try { map = JSON.parse(block.dataset.finishMap || '{}'); } catch (_) {}
      const selected = block.querySelector('.mg-v5-finish-tab.is-selected');
      const name = selected?.dataset.finishName;
      const info = block.querySelector('.mg-v5-finish-info');
      if (info) info.textContent = map[name] || '';
    });
    if (!variantState.transition) {
      const price = readCurrentPrice(form, root);
      document.querySelectorAll('.mg-v5-choice-price').forEach((node) => {
        if (node.textContent !== price) node.textContent = price;
        node.hidden = !price;
      });
      mgSyncValueSummary(form, root, price);
      const comparePrices = {
        'Standard': '139,99 €',
        'Premium': '159,99 €',
        'Premium Plus': '179,99 €'
      };
      const comparePrice = isSaleSizeKey(variantState.size) ? (comparePrices[variantState.finish] || '') : '';
      document.querySelectorAll('.mg-v5-choice-compare-price').forEach((node) => {
        if (node.textContent !== comparePrice) node.textContent = comparePrice;
        node.hidden = !comparePrice;
      });
    }
  }

  function collapseNativeShell(form) {
    if (!form) return;
    Array.from(form.children).forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      if (child.classList.contains('mg-v5-panel')) return;
      if (child.matches('script, style, template, .tee-dialog, .vm--container, [role="dialog"], [role="listbox"]')) return;
      child.classList.add('mg-v5-native-shell-hidden');
    });
  }

  function compactGallery(root) {
    const wrapper = root.querySelector('.product__media-wrapper');
    const teeGallery = wrapper?.querySelector('#tee-gallery, .tee-gallery-content');
    if (!wrapper || !teeGallery) return;

    wrapper.classList.add('mg-v5-gallery-ready');
    const nativeCandidates = wrapper.querySelectorAll('media-gallery, [id^="GalleryViewer-"], .product__media-list, .thumbnail-slider, slider-component');
    nativeCandidates.forEach((el) => {
      if (el === teeGallery || el.contains(teeGallery) || teeGallery.contains(el)) return;
      el.classList.add(LAYOUT_HIDDEN);
    });

    Array.from(wrapper.children).forEach((child) => {
      if (child === teeGallery || child.contains(teeGallery)) return;
      if (child.matches?.('script, style')) return;
      if (child.querySelector?.('.tee-gallery-content, #tee-gallery')) return;
      if (child.matches?.('media-gallery, slider-component, [id^="GalleryViewer-"], .product__media-list, .thumbnail-slider')) child.classList.add(LAYOUT_HIDDEN);
    });

    wrapper.style.height = 'fit-content';
    wrapper.style.minHeight = '0';
    wrapper.style.alignSelf = 'start';
  }

  function prepareLiteNativeUi(form) {
    if (!form) return;
    document.querySelectorAll('.mg-live-preview').forEach((node) => node.classList.add('mg-v5-lite-suppressed'));
    document.querySelectorAll('.tee-product-price').forEach((node) => node.classList.add('mg-v5-lite-suppressed'));
    const nativeFinish = document.querySelector('#tee-field--teeinblue-available-prod') || form.querySelector('.tee-available-products');
    if (nativeFinish) nativeFinish.classList.add('mg-v5-lite-suppressed');
    form.querySelectorAll('.tee-customization-wrapper > .tee-available-products, .tee-customization-wrapper > .tee-variants > .tee-option--size').forEach((node) => node.classList.add('mg-v5-lite-suppressed'));
    const wrapper = form.querySelector('.tee-customization-wrapper') || form.querySelector('.tee-form-inputs')?.parentElement || form.querySelector('.tee-form-inputs');
    form.querySelectorAll('.mg-v5-lite-native-card').forEach((node) => node.classList.remove('mg-v5-lite-native-card'));
    if (wrapper && wrapper !== form) wrapper.classList.add('mg-v5-lite-native-card');
  }

  function build(root, form) {
    if (form.dataset.mgV5Built === '1') return;

    try {
      prepareLiteNativeUi(form);

      const panel = document.createElement('div');
      panel.className = 'mg-v5-lite-panel';

      const choiceSection = createSection('Größe & Ausführung', 'Wähle Format und Haltbarkeit.', 'mg-v5-choice-section');
      const head = choiceSection.querySelector('.mg-v5-section-head');
      const priceWrap = document.createElement('div');
      priceWrap.className = 'mg-v5-choice-price-wrap';
      const comparePrice = document.createElement('del');
      comparePrice.className = 'mg-v5-choice-compare-price';
      comparePrice.hidden = true;
      const price = document.createElement('strong');
      price.className = 'mg-v5-choice-price';
      price.hidden = true;
      priceWrap.append(comparePrice, price);
      head?.append(priceWrap);
      const choiceBody = document.createElement('div');
      choiceBody.className = 'mg-v5-choice-body';
      choiceSection.append(choiceBody);
      panel.append(choiceSection);
      buildSizes(choiceBody, form);
      buildFinish(choiceBody, form);
      mgBuildValueSummary(choiceBody);

      buildPurchase(panel, form);

      const actions = form.querySelector('.tee-form-actions');
      if (actions?.parentNode) actions.parentNode.insertBefore(panel, actions);
      else form.append(panel);

      form.dataset.mgV5Built = '1';
      root.classList.add('mg-v5-lite-active');
      document.body.classList.add('mg-v5-lite-active');
      sync(root, form);
    } catch (error) {
      document.querySelectorAll('.mg-v5-lite-panel, .mg-v5-lite-hero').forEach((node) => node.remove());
      form.dataset.mgV5Built = '0';
      root.classList.remove('mg-v5-lite-active');
      document.body.classList.remove('mg-v5-lite-active');
      document.querySelectorAll('.' + NATIVE_HIDDEN).forEach((element) => element.classList.remove(NATIVE_HIDDEN));
      console.error('[MG Customizer Lite]', error);
    }
  }

  function resetIfRebuilt(form) {
    if (!form) return;
    const panel = form.querySelector(':scope > .mg-v5-lite-panel');
    if (!panel) form.dataset.mgV5Built = '0';
  }

  function boot() {
    const root = document.querySelector(ROOT);
    if (!root) return;
    if (!customizerEnabled(root)) {
      disableCustomizer(root);
      return;
    }
    if (bootedRoots.has(root)) return;
    bootedRoots.add(root);
    let running = false;

    const enhance = () => {
      if (running) return;
      running = true;
      requestAnimationFrame(() => {
        running = false;
        if (!root.isConnected || !customizerEnabled(root)) return;
        const form = document.querySelector(FORM);
        if (!form) return;
        resetIfRebuilt(form);
        prepareLiteNativeUi(form);
        build(root, form);
        sync(root, form);
      });
    };

    enhance();
    document.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement) requestAnimationFrame(() => sync(root, document.querySelector(FORM)));
    }, true);

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        if (!mutation.addedNodes.length && !mutation.removedNodes.length) return false;
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (target?.closest?.('.mg-v5-lite-panel, #mg-draft-save-root')) return false;
        return true;
      });
      if (relevant) enhance();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches(ROOT) || target.querySelector(ROOT)) boot();
  });
})();
